import { useRef as t } from "react";
const s = () => {
  const r = t(null), e = t(Date.now());
  return {
    check: () => {
      const n = Date.now(), c = r.current ? n - e.current : void 0;
      return r.current = e.current, e.current = n, c;
    }
  };
};
export {
  s as useTimer
};
